import {Component, OnChanges, OnInit, Optional, SimpleChanges} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';
import {BehaviorSubject, combineLatest, filter, Observable, of, switchMap, take, takeUntil} from 'rxjs';
import {environment} from "../../../../../environments/environment";
import {PermissionService} from "@core/permission.service";
import {RolesEnum} from "@shared/enums/roles.enum";
import {NavigateService} from "@core/services/navigate.service";
import {ActivatedRoute, IsActiveMatchOptions, NavigationEnd, Router} from "@angular/router";
import {DestroySubscription} from "@helpers";
import {TenantService} from "../../../tenants/modules/tenant/services/tenant.service";

@Component({
    selector: 'app-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.less'],
})
export class NavigationMenuComponent extends DestroySubscription implements OnInit, OnChanges {
    auth$: Observable<boolean>;
    showMenu$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    show$: Observable<boolean>;
    env = environment;
    isTenantsAvailable: boolean;
    isFairLaunchAvailable: boolean;
    isFarmsAvailable: boolean;
    isStatisticsAvailable: boolean;
    isTenants = false;
    isFairLaunch = false;
    isFarm = false;
    isStatistics = false

    constructor(
        private readonly auth: AuthService,
        private readonly permissionService: PermissionService,
        private readonly navigateService: NavigateService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        @Optional() private readonly tenantService: TenantService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.auth$ = this.auth.isAuthenticated$;
        this.permissionService.isReady.pipe(
            filter((r) => r),
            take(1),
        ).subscribe(_ => {

            this.isTenantsAvailable = !!this.permissionService.tenantId && this.permissionService.isInRoles([RolesEnum.ProjectAdmin, RolesEnum.TenantAdmin, RolesEnum.ProjectMember]);
            this.isFairLaunchAvailable = !!this.permissionService.tenantId && this.permissionService.isInRoles([RolesEnum.FairLaunch, RolesEnum.FairLaunchAdmin]);
            this.isFarmsAvailable = !!this.permissionService.tenantId && this.permissionService.isInRoles([RolesEnum.FarmsAdmin]);
            this.isStatisticsAvailable = !!this.permissionService.tenantId && this.permissionService.isInRoles([RolesEnum.Statistics]);
            if (this.isTenantsAvailable && (this.isFairLaunchAvailable || this.isFarmsAvailable || this.isStatisticsAvailable)) {
                this.showMenu$.next(true);
            } else {
                this.showMenu$.next(false);
            }
        })

        this.show$ = combineLatest([
            this.auth$,
            this.showMenu$.asObservable()
        ]).pipe(
            switchMap(([isAuth, isShow]) => (of(isAuth && isShow))),
            takeUntil(this.destroyStream$),
        )

        this.getActiveMenu();

    }

    ngOnChanges(changes: SimpleChanges) {
    }

    toTenants() {
        this.navigateService.navigateToTenants();
    }

    toFairLaunch() {
        this.navigateService.navigateToFairLaunch();
    }

    toFarms() {
        this.navigateService.navigateToFarms();
    }

    toStatistics() {
        this.navigateService.navigateToStatistics();
    }

    logout() {
        this.auth.logout({ logoutParams: {returnTo: document.location.origin }});
    }

    private getActiveMenu(): void {
        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            takeUntil(this.destroyStream$),
        ).subscribe(navigate => {
            const matchOptions: IsActiveMatchOptions = {
                paths: 'subset',
                matrixParams: 'ignored',
                queryParams: 'ignored',
                fragment: 'ignored'
            }
            const urlArray = (navigate as NavigationEnd)?.url?.split('/');
            this.isTenants = this.router.isActive('tenants', matchOptions);
            this.isFairLaunch = this.router.isActive('fair-launch', matchOptions);
            this.isFarm = this.router.isActive(`farms`, matchOptions);
            this.isStatistics = this.router.isActive('statistics', matchOptions);
        })
    }
}
